<template>
	<transition name="v2-modal-transition">
		<div class="v2r-modal-overlay" @click.self="close">
			<div class="v2r-modal">
				<div class="v2r-modal__head">
					<div class="v2r-modal__icon v2r-modal__icon--yellow">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
					</div>
					<div>
						<div class="v2r-modal__title">{{ $t('campaign.cannot_approve_yet') || 'Cannot approve yet' }}</div>
						<div class="v2r-modal__sub">{{ $t('campaign.resolve_blocking_issues') || 'Resolve the following blocking issues before approval' }}</div>
					</div>
				</div>
				<div class="v2r-modal__body">
					<div class="v2r-modal__list">
						<div
							v-for="(message, i) in approveWarnings"
							:key="i"
							class="v2r-modal__list-item"
						>
							<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
							<div v-html="message" />
						</div>
					</div>
				</div>
				<div class="v2r-modal__foot">
					<button class="v2r-modal__btn v2r-modal__btn--primary" @click="close">
						{{ $t('close') | capitalize }}
					</button>
				</div>
			</div>
		</div>
	</transition>
</template>


<script>
export default {
	name: 'V2ApproveWarningsModal',

	props: {
		approveWarnings: {
			type: Array,
			required: true,
		},
	},

	methods: {
		close() {
			this.$emit('close');
		},
	},
};
</script>


<style lang="sass" scoped>
@import '~@/assets/styles/v2-tokens.sass'
@import './modal-shared'
</style>
